import VueLogger from 'vuejs3-logger'
import {createApp} from 'vue'

export const isProduction = process.env.NODE_ENV === 'production';

const vlOptions = {
    isEnabled: true,
    logLevel: isProduction ? 'info' : 'debug',
    stringifyArguments: true,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
};

let urlParams = new URLSearchParams(window.location.search);
const newLogLevel = urlParams.get('logging')
if (newLogLevel) {
    console.log("Setting log level to " + newLogLevel);
    vlOptions.logLevel = newLogLevel;
    sessionStorage.setItem("logging", newLogLevel.toLowerCase())
} else {
    const sessionLogLevel = sessionStorage.getItem("logging")
    if (sessionLogLevel) {
        console.log("Resetting (from Session) log level to " + sessionLogLevel);
        vlOptions.logLevel = sessionLogLevel.toLowerCase();
    }
}
// create a dummy app that can be used as logger in other js modules
const app = createApp({})
app.use(VueLogger, vlOptions);
const logger = app.config.globalProperties.$log;

export {VueLogger, vlOptions, logger};